import { IPhysician, IPhysicianListState } from 'entities/Physician/Physician.models';

export const physicianListReducers = {
  setList: (state: IPhysicianListState, payload: IPhysician[]) => ({ ...state, data: payload }),
  setLoading: (state: IPhysicianListState, payload: boolean) => ({ ...state, loading: payload }),
};
